import React from 'react'
import { Box } from '@material-ui/core'
import { CloseIcon, CloudUploadIcon } from '~/assets/icons'
import { mutualTheme } from '~/utils/theme'

export type ResponsiveActionButtonsProps = {
  rootProps: any,
  hasFile: Boolean,
  isCompleted: boolean,
  removeItem: () => void,
  canRemove?: boolean
}

export const ResponsiveActionButtons: React.FC<ResponsiveActionButtonsProps> = (props) => {
  const { rootProps, removeItem, isCompleted, canRemove, hasFile } = props

  return (
    <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 1 }}>
      <CloudUploadIcon htmlColor={mutualTheme.palette.secondary.main} {...rootProps()} />
      {(canRemove || hasFile) && !isCompleted && <CloseIcon onClick={removeItem} htmlColor={mutualTheme.palette.secondary.main} />}
    </Box>
  )
}
